var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card noselect card-img-holder text-white",
      class: [
        _vm.hovered ? "shadow-lg bg-primary" : "shadow-sm bg-dark",
        _vm.linkEnabled ? "cursor-pointer" : "",
        _vm.hoverEnabled ? "card-hover" : ""
      ],
      on: {
        click: _vm.openSeries,
        mouseenter: function($event) {
          _vm.hovered = true
        },
        mouseleave: function($event) {
          _vm.hovered = false
        }
      }
    },
    [
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.imageLoaded,
            expression: "imageLoaded"
          }
        ],
        staticClass: "card-img-top",
        attrs: {
          src: _vm.series.thumbnail_url,
          alt: _vm.series.title[_vm.$i18n.locale]
        },
        on: {
          load: function($event) {
            _vm.imageLoaded = true
          }
        }
      }),
      _vm._v(" "),
      !_vm.imageLoaded
        ? _c(
            "div",
            {
              staticClass: "text-center bg-light",
              staticStyle: { "padding-top": "80px", "padding-bottom": "80px" }
            },
            [
              _c("i", {
                staticClass: "mdi mdi-spin mdi-autorenew mdi-36px text-primary"
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("img", {
          staticClass: "card-img-absolute",
          attrs: { src: "/images/dashboard/circle.svg", alt: "circle-image" }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "mb-3" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.series.title[_vm.$i18n.locale]) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _vm.series.description !== null
          ? _c("p", [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.series.description[_vm.$i18n.locale]) +
                  "\n            "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h5", { staticClass: "font-weight-lighter mb-3" }, [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.$t("pages.series.card.video_count", {
                  count: _vm.series.video_count
                })
              ) +
              "\n            "
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }